import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { Routes, Route } from 'react-router-dom'; // RoutesとRouteをインポート
import axios from 'axios';
import RecipeForm from './components/RecipeForm';
import RecipeList from './components/RecipeList';
import RecipeDetail from './components/RecipeDetail'; // RecipeDetailをインポート
import './App.css'; // 後で作成するCSSファイルをインポート
import { useAuth } from "react-oidc-context";

function App() {
    const auth = useAuth();
    const [recipes, setRecipes] = useState([]);

    const signOutRedirect = useCallback(() => {
        const clientId = process.env.REACT_APP_USER_POOL_CLIENT_ID;
        const logoutUri = process.env.REACT_APP_REDIRECT_URI;
        const cognitoDomain = process.env.REACT_APP_COGNITO_DOMAIN;
        // const idTokenHint = auth.user?.id_token; // idTokenHint は含めない

        let logoutUrl = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
        // idTokenHint は含めない
        window.location.href = logoutUrl;
    }, []); // idTokenHint を依存配列から削除

    // axiosのインスタンスを作成し、認証ヘッダーを自動的に追加
    const api = useMemo(() => {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_ENDPOINT,
        });

        instance.interceptors.request.use(async (config) => {
            try {
                if (auth.isAuthenticated && auth.user?.id_token) {
                    config.headers.Authorization = `Bearer ${auth.user.id_token}`;
                }
            } catch (error) {
                console.error('Error getting auth token:', error);
            }
            return config;
        });
        return instance;
    }, [auth.isAuthenticated, auth.user?.id_token]); // 認証状態またはIDトークンが変更されたときのみ再生成

    // 初回ロード時にレシピを取得
    useEffect(() => {
        const fetchRecipes = async () => {
            try {
                const response = await api.get('/recipes');
                setRecipes(response.data);
            } catch (error) {
                console.error('レシピの取得に失敗しました:', error);
            }
        };
        fetchRecipes();
    }, [api]); // apiを依存関係に追加

    // 新しいレシピが追加された時、またはリストが更新された時にstateを更新
    const handleRecipeUpdate = useCallback((updatedRecipes) => {
        setRecipes(updatedRecipes);
    }, []); // setRecipesはReactによって安定した参照が保証されるため、依存配列から除外可能

    if (auth.isLoading) {
        return <div>Loading...</div>;
    }

    if (auth.error) {
        return <div>Encountering error... {auth.error.message}</div>;
    }

    return (
        <div className="App" style={{ maxWidth: '1200px', margin: '0 auto', padding: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '20px' }}>
                {!auth.isAuthenticated ? (
                    <button onClick={() => auth.signinRedirect()} style={{
                        backgroundColor: '#007bff',
                        color: 'white',
                        padding: '10px 20px',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        fontSize: '16px'
                    }}>サインイン</button>
                ) : (
                    <button onClick={() => signOutRedirect()} style={{
                        backgroundColor: '#dc3545',
                        color: 'white',
                        border: 'none',
                        padding: '10px 15px',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        fontSize: '1em'
                    }}>サインアウト</button>
                )}
            </div>
            <h1 style={{ textAlign: 'center', color: '#333' }}>レシピ管理アプリ</h1>
            {auth.isAuthenticated && (
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                    <p>こんにちは {auth.user?.profile.email}</p>
                </div>
            )}
            <Routes>
                <Route path="/" element={
                    <>
                        {auth.isAuthenticated && <RecipeForm onRecipeAdded={handleRecipeUpdate} api={api} />}
                        <RecipeList recipes={recipes} onRecipeUpdated={handleRecipeUpdate} api={api} />
                    </>
                } />
                <Route path="/recipes/:id" element={<RecipeDetail api={api} isAuthenticated={auth.isAuthenticated} />} />
            </Routes>
        </div>
    );
}

export default App;
